import { useState } from 'react';
import Account from './Account';
import WalletsDesktop from './WalletsDesktop';
import AccountSecurityDekstop from './AccountSecurityDekstop';
import AccountSupport from './AccountSupport';
import { useUserCloudQuery } from '@/hooks/onboarding/useReferralQuery';
export default function AccountController() {
  const [currentTap, setCurrentTap] = useState<'account' | 'wallets' | 'security' | 'settings' | 'support'>('account');
  const {
    data: cloudData
  } = useUserCloudQuery();
  return <div className='h-full' data-sentry-component="AccountController" data-sentry-source-file="index.tsx">
      <div className='flex items-center text-[20px] text-genius-cream/50 gap-3'>
        <div onClick={() => setCurrentTap('account')} className={`cursor-pointer ${currentTap === 'account' && 'text-genius-cream'}`}>
          Account
        </div>
        <div onClick={() => setCurrentTap('wallets')} className={`cursor-pointer ${currentTap === 'wallets' && 'text-genius-cream'}`}>
          Wallets
        </div>
        <div onClick={() => setCurrentTap('security')} className={`cursor-pointer ${currentTap === 'security' && 'text-genius-cream'}`}>
          Security
        </div>
        <div onClick={() => setCurrentTap('support')} className={`cursor-pointer ${currentTap === 'support' && 'text-genius-cream'}`}>
          Support
        </div>
      </div>
      <div className='h-full pt-5 w-full'>
        {currentTap === 'account' && <div className='px-8 w-full'>
            <Account userInfo={cloudData} />
          </div>}
        {currentTap === 'wallets' && <WalletsDesktop />}
        {currentTap === 'security' && <AccountSecurityDekstop />}
        {currentTap === 'support' && <AccountSupport />}
      </div>
    </div>;
}